.page-navigation-profile {
  .avatar {
    max-width: 43px;
    max-height: 43px;
    float: left;
    margin: 0 10px 0 0;
  }
}
